const _HeaderSearch = class {
  constructor() {
    this.openOverlayElements = document.querySelectorAll(_HeaderSearch.openOverlayElementsLocator);
    this.closeOverlayElements = document.querySelectorAll(_HeaderSearch.closeOverlayElementsLocator);
    this.searchBox = document.querySelector(_HeaderSearch.searchBoxLocator);
    this.searchBoxInput = document.querySelector("#ke_search_sword");
    this.focusableElements = [];
    this.currentFocusIndex = -1;
    this.originalFocus = null;
    this.isReady = false;
    this.desktopOverlayActive = false;
    this.closeOnEscKeyHandler = (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    };
  }
  init() {
    if (this.searchBox) {
      this.focusableElements = Array.from(this.searchBox ? this.searchBox.querySelectorAll(".focusTrap--focusable") : []);
      this.addEventListeners();
    }
    this.isReady = true;
  }
  addEventListeners() {
    this.openOverlayElements.forEach((element) => element.addEventListener("click", () => this.open()));
    this.closeOverlayElements.forEach((element) => {
      element.addEventListener("click", () => this.close());
      element.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.close();
        }
      });
    });
    this.focusableElements.forEach((focusableElement, index) => {
      focusableElement.addEventListener("focusin", () => {
        this.currentFocusIndex = index;
      });
    });
  }
  open() {
    if (!this.isReady)
      this.init();
    this.openOverlayElements.forEach((element) => element.setAttribute("aria-expanded", "true"));
    if (this.searchBox) {
      this.searchBox.classList.add("kesearch_searchbox--active");
      this.searchBox.setAttribute("aria-hidden", "false");
    }
    this.desktopOverlayActive = true;
    document.addEventListener("keydown", this.closeOnEscKeyHandler);
    this.originalFocus = document.activeElement;
    if (this.searchBoxInput) {
      this.searchBoxInput.focus();
    }
    this.trapFocus();
  }
  close() {
    if (!this.isReady)
      this.init();
    this.closeOverlayElements.forEach((element) => element.setAttribute("aria-expanded", "false"));
    if (this.searchBox) {
      this.searchBox.classList.remove("kesearch_searchbox--active");
      this.searchBox.setAttribute("aria-hidden", "true");
    }
    this.desktopOverlayActive = false;
    document.removeEventListener("keydown", this.closeOnEscKeyHandler);
    this.removeTrap();
    if (this.originalFocus) {
      this.originalFocus.focus();
    }
  }
  trapFocus() {
    if (this.searchBox) {
      this.handleTabKey = this.handleTabKey.bind(this);
      this.searchBox.addEventListener("keydown", this.handleTabKey);
    }
  }
  removeTrap() {
    if (this.searchBox) {
      this.searchBox.removeEventListener("keydown", this.handleTabKey);
    }
  }
  handleTabKey(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      event.shiftKey ? this.prevIndex() : this.nextIndex();
      if (this.focusableElements[this.currentFocusIndex]) {
        this.focusableElements[this.currentFocusIndex].focus();
      }
    }
  }
  nextIndex() {
    this.currentFocusIndex = this.currentFocusIndex >= this.focusableElements.length - 1 ? 0 : this.currentFocusIndex + 1;
  }
  prevIndex() {
    this.currentFocusIndex = this.currentFocusIndex == 0 ? this.focusableElements.length - 1 : this.currentFocusIndex - 1;
  }
};
let HeaderSearch = _HeaderSearch;
HeaderSearch.searchBoxLocator = ".kesearch_searchbox";
HeaderSearch.openOverlayElementsLocator = ".desktop-search-entry-button";
HeaderSearch.closeOverlayElementsLocator = ".desktop-search-close-button";
export default HeaderSearch;
